import React, { useEffect, useState } from 'react';
import './Hero.css';
import { FaTools, FaShieldAlt, FaWhatsapp, FaClock, FaCheckCircle, FaArrowDown } from 'react-icons/fa';

const Hero = () => {
  const [offsetY, setOffsetY] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      setOffsetY(window.pageYOffset);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToContact = () => {
    document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' });
  };

  const scrollToServices = () => {
    document.getElementById('services')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="accueil" className="hero">
      {/* Animated Background Elements */}
      <div className="hero-bg">
        <div className="hero-bg-gradient"></div>
        <div className="hero-shapes">
          <div className="shape shape-1" style={{ transform: `translateY(${offsetY * 0.5}px)` }}></div>
          <div className="shape shape-2" style={{ transform: `translateY(${offsetY * 0.3}px)` }}></div>
          <div className="shape shape-3" style={{ transform: `translateY(${offsetY * 0.4}px)` }}></div>
        </div>
        <div className="hero-pattern"></div>
      </div>

      <div className="hero-container">
        <div className="hero-content">
          {/* Main Content */}
          <div className="hero-text">
            <div className="hero-badge fade-in-down">
              <FaCheckCircle className="badge-icon" />
              <span>Professionnel Certifié</span>
            </div>

            <h1 className="hero-title fade-in-up">
              Votre Expert en
              <span className="hero-title-gradient"> Plomberie</span>
              <br />
              <span className="hero-title-highlight">Solutions Rapides & Garanties</span>
            </h1>

            <p className="hero-description fade-in-up">
              Interventions d'urgence 7j/7, installations professionnelles et rénovations complètes.
              Plus de 20 ans d'expertise à votre service avec garantie décennale.
            </p>

            {/* Features */}
            <div className="hero-features fade-in-up">
              <div className="feature-item">
                <div className="feature-icon">
                  <FaTools />
                </div>
                <div className="feature-text">
                  <strong>20 ans</strong>
                  <span>d'expérience</span>
                </div>
              </div>
              <div className="feature-item">
                <div className="feature-icon">
                  <FaClock />
                </div>
                <div className="feature-text">
                  <strong>7j/7</strong>
                  <span>Disponible</span>
                </div>
              </div>
              <div className="feature-item">
                <div className="feature-icon">
                  <FaShieldAlt />
                </div>
                <div className="feature-text">
                  <strong>Garantie</strong>
                  <span>Décennale</span>
                </div>
              </div>
            </div>

            {/* CTA Buttons */}
            <div className="hero-cta fade-in-up">
              <button onClick={scrollToContact} className="btn btn-primary btn-large pulse-animation">
                <FaTools /> Devis Gratuit
              </button>
              <a 
                href={`https://wa.me/${process.env.REACT_APP_WHATSAPP_NUMBER || '33123456789'}`}
                target="_blank" 
                rel="noopener noreferrer" 
                className="btn btn-whatsapp btn-large"
              >
                <FaWhatsapp /> WhatsApp
              </a>
            </div>

            {/* Scroll Indicator */}
            <button className="scroll-indicator" onClick={scrollToServices} aria-label="Scroll down">
              <FaArrowDown />
              <span>Découvrir nos services</span>
            </button>
          </div>

          {/* Hero Card - Floating Info */}
          <div className="hero-card-wrapper fade-in-right">
            <div className="hero-card float-animation">
              <div className="hero-card-bg"></div>
              <div className="hero-card-content">
                <div className="hero-card-icon">
                  <FaClock className="clock-icon" />
                </div>
                <h3>Intervention Rapide</h3>
                <p className="hero-card-text">
                  Dépannage d'urgence sous <strong>1h</strong> dans votre secteur
                </p>
                <div className="hero-card-features">
                  <div className="card-feature">
                    <FaCheckCircle />
                    <span>Devis immédiat</span>
                  </div>
                  <div className="card-feature">
                    <FaCheckCircle />
                    <span>Tarif transparent</span>
                  </div>
                  <div className="card-feature">
                    <FaCheckCircle />
                    <span>Paiement facilité</span>
                  </div>
                </div>
                <div className="hero-card-badge">
                  <div className="badge-pulse"></div>
                  <span>Disponible maintenant</span>
                </div>
              </div>
            </div>

            {/* Floating Stats */}
            <div className="floating-stat stat-1">
              <div className="stat-number">500+</div>
              <div className="stat-label">Clients Satisfaits</div>
            </div>
            <div className="floating-stat stat-2">
              <div className="stat-number">100%</div>
              <div className="stat-label">Garantie Travaux</div>
            </div>
          </div>
        </div>
      </div>

      {/* Animated Water Drops */}
      <div className="water-drops">
        <div className="water-drop drop-1"></div>
        <div className="water-drop drop-2"></div>
        <div className="water-drop drop-3"></div>
        <div className="water-drop drop-4"></div>
        <div className="water-drop drop-5"></div>
      </div>
    </section>
  );
};

export default Hero;
